import React, { useEffect, useState } from 'react';
import {
  IN_ROOM_DINING_COMBO_EDIT,
  IN_ROOM_DINING_COMBO_TAB,
  IN_ROOM_DINING_MENU_VIEW,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import InRoomDiningComboViewDetail from './Combo-View-Detail';
import { inRoomDiningCombosSelector } from '../../../servicesSlice';
import { useSelector } from 'react-redux';

const InRoomDiningComboView = (props) => {
  const inRoomDiningCombo = useSelector(inRoomDiningCombosSelector);
  const { combo, toggleDrawer, onViewToggle, menuViewObject, setMenuViewObject, permissions } =
    props;
  const [tabValue, setTabValue] = useState(0);
  const [currentCombo, setCurrentCombo] = useState(null);

  useEffect(() => {
    if (inRoomDiningCombo.length) {
      let comboObj = {
        ...inRoomDiningCombo.find((tempComboInfo) => tempComboInfo.id === combo.id),
      };
      setCurrentCombo(comboObj);
    }
  }, [inRoomDiningCombo]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, currentCombo);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(IN_ROOM_DINING_COMBO_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <InRoomDiningComboViewDetail tabValue={tabValue} combo={currentCombo} />;
  };

  const onClickBack = () => {
    if (menuViewObject) {
      const menuObject = { ...menuViewObject };
      setMenuViewObject(null);
      onViewToggle(IN_ROOM_DINING_MENU_VIEW, true, menuObject);
    } else {
      onViewToggle(null, false, null);
    }
  };

  return (
    <>
      {currentCombo && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          onClickBack={onClickBack}
          tabValue={tabValue}
          tabList={IN_ROOM_DINING_COMBO_TAB}
          onViewToggle={onViewToggle}
          title={currentCombo.name}
          createdUserId={currentCombo.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default InRoomDiningComboView;
